module.exports = __webpack_public_path__ + "static/media/Shroomish_gaussian2.4838f426.png";